import React, { Component, cloneElement, Children, Fragment } from 'react';
import { Nav, List, ListItem, ListPanel } from './style';
export * from './style';

const NavList = ({ children, activeIndex, onActivate }) => (
  <Nav>
    <List>
      {Children.map(children, (child, idx) =>
        cloneElement(child, {
          isActive: idx === activeIndex,
          onClick: () => onActivate(idx),
        })
      )}
    </List>
  </Nav>
);

const NavListItem = ({ onClick, isActive, children }) => (
  <ListItem onClick={onClick} className={isActive ? 'active' : ''}>
    {children}
  </ListItem>
);

const NavListPanel = ({ children }) => <ListPanel>{children}</ListPanel>;

const NavListPanels = ({ children, activeIndex }) => (
  <Fragment>{children[activeIndex]}</Fragment>
);

class TabNav extends Component {
  state = {
    activeIndex: 0,
  };

  static NavList = NavList;
  static NavListItem = NavListItem;
  static NavListPanel = NavListPanel;
  static NavListPanels = NavListPanels;

  render() {
    const { activeIndex } = this.state;
    const { children, onActivate } = this.props;
    const cx = Children.map(
      children,
      child =>
        child.type === NavList
          ? cloneElement(child, {
            activeIndex,
            onActivate: idx =>
              this.setState(
                {
                  activeIndex: idx,
                },
                () => (onActivate != null ? onActivate() : undefined)
              ),
          })
          : child.type === NavListPanels
            ? cloneElement(child, {
              activeIndex,
            })
            : child
    );

    return <Fragment>{cx}</Fragment>;
  }
}

export default TabNav;



// WEBPACK FOOTER //
// ../shop_main/components/tabNav/index.js